/**
 * Utility function to normalize phone numbers to international E.164 format (+92...)
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";
  let str = String(phone).trim();

  let cleaned = str.replace(/[^0-9+]/g, "");

  if (!cleaned) return "";

  if (cleaned.startsWith("+0")) {
    cleaned = "+92" + cleaned.slice(2);
  }

  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  } else if (cleaned.startsWith("0")) {
    cleaned = "+92" + cleaned.slice(1);
  } else if (cleaned.startsWith("3") && cleaned.length >= 9 && cleaned.length <= 11) {
    cleaned = "+92" + cleaned;
  } else if (cleaned.startsWith("92") && cleaned.length > 4) {
    cleaned = "+" + cleaned;
  }

  if (!cleaned.startsWith("+") && cleaned.length > 0) {
    cleaned = "+" + cleaned;
  }

  return cleaned;
};
